import styled from 'styled-components'
import { theme } from '../styles/GlobalStyle'
import bg from '../assets/images/bg.jpg'

const HeaderStyle = styled.div`
  header {
    background-color: ${theme.dark};
    background-image: linear-gradient(
        to bottom,
        rgba(13, 29, 48, 0.54) 0%,
        rgba(13, 29, 48, 0.54) 100%
      ),
      url(${bg});
    background-repeat: no-repeat;
    background-position: center top;
    background-size: cover;
    height: 651px;
    position: relative;
  }
  .navbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    height: 80px;
    max-width: 1360px;
    margin-left: auto;
    margin-right: auto;
  }
  .navbar-header {
    align-self: center;
  }
  .navbar-brand {
    font-family: Airwave-Regular, sans-serif;
    font-size: 42px;
    color: white;
    line-height: 1.31;
    letter-spacing: 1.3px;
  }

  .screen {
    position: absolute;
    bottom: 0;
    margin-bottom: -100px;
  }

  .desc-container > h1 {
    font-size: 42px;
    font-weight: 300;
    line-height: 1.52;
    color: #fff;
    text-align: center;
    padding-top: 3.3vw;
  }

  #sectionBtn {
    height: 134px;
    position: absolute;
    z-index: 2;
    background-color: #fff;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid ${theme.border};
  }

  @media (min-width: 768px) {
    .menu {
      display: none;
    }
  }
  @media (max-width: 767px) {
    header {
      height: 600px;
    }
    .desc-container > h1 {
      font-size: 5.3vw;
    }
    .navbar {
      justify-content: space-between;
    }

    .menu {
      display: flex;
    }
  }
  @media (max-width: 640px) {
    header {
      height: 520px;
    }
  }
  @media (max-width: 480px) {
    header {
      height: 440px;
    }
    .screen {
      margin-bottom: -46px;
    }
  }
  @media (max-width: 320px) {
    header {
      height: 320px;
    }
    .screen {
      margin-bottom: -50px;
    }
  }
`
export default HeaderStyle
